import type { AnonymizationRepository } from '@/modules/task/domain/anonymization/AnonymizationRepository';
import { Anonymization } from '@/modules/task/domain/anonymization/Anonymization';
import { anonymizationData } from '@/modules/anonymization/public/api';

export class ApiAnonymizationRepository implements AnonymizationRepository {
  get(): Anonymization {
    return new Anonymization(anonymizationData().isEnabled());
  }
}
